module.exports = __webpack_public_path__ + "static/media/senionHighSchool_8.9010734e.png";